import * as React from 'react';
import { Component } from 'react';
import {
  Wrapper,
  FormWrapper,
  FormHeader,
  FormControlsWrapper,
  FormContentWrapper,
  FormButton,
  FormContentPage,
  FormSectionName,
  FormInput,
  SubText,
  FormTextarea,
  AddPhotoButton,
  QuizDoneWrapper,
  DoneIconWrapper,
  DoneText,
  DoneParagraph,
  DoneParagraphWrapper,
} from './ProForm.s';
import { FormProgress } from '@components/FormProgress/FormProgress';

type ProFormState = {
  progress: number;
  quizDone: boolean;
};

export class ProForm extends Component<{}, ProFormState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      progress: 0,
      quizDone: false,
    };
  }

  render(): JSX.Element {
    return (
      <Wrapper>
        <QuizDoneWrapper
          style={{ transform: `translateX(${this.state.quizDone ? 0 : 100}%)`, opacity: this.state.quizDone ? 1 : 1 }}
        >
          <DoneIconWrapper>
            <svg width="99" height="99" viewBox="0 0 99 99" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd">
                <ellipse fill="#6744C6" cx="49.5" cy="49.5" rx="49.5" ry="49.5" />
                <path
                  stroke="#FFF"
                  strokeWidth="4"
                  strokeLinecap="round"
                  d="M24 50.733438l16.319074 16.319074L71.371587 36"
                />
              </g>
            </svg>
          </DoneIconWrapper>
          <DoneText>Félicitations</DoneText>
          <DoneParagraphWrapper>
            <DoneParagraph>
              Nous vous contacterons très prochainement au sujet de la mise en ligne votre exposition sur <b>start.</b>
            </DoneParagraph>
          </DoneParagraphWrapper>
        </QuizDoneWrapper>
        <FormWrapper
          style={{ transform: `translateX(${this.state.quizDone ? -100 : 0}%)`, opacity: this.state.quizDone ? 1 : 1 }}
        >
          <FormHeader>
            Mettez en ligne votre exposition sur <b>start.</b>
          </FormHeader>
          <FormProgress progress={this.state.progress} />
          <FormContentWrapper style={{ transform: `translateX(${-(100 / 5) * this.state.progress}%)` }}>
            <FormContentPage>
              <FormSectionName>Où se trouve votre exposition ?</FormSectionName>
              <FormInput type="text" placeholder="Nom du lieu d’exposition *" />
              <FormInput type="text" placeholder="Adresse *" />
              <FormInput type="text" placeholder="Code Postal *" />
              <FormInput type="text" placeholder="Ville *" />
            </FormContentPage>
            <FormContentPage>
              <FormSectionName>Comment peut-on vous joindre pour discuter de votre exposition ?</FormSectionName>
              <FormInput type="text" placeholder="Adresse e-mail*" />
              <FormInput type="text" placeholder="Numéro de téléphone" />
              <SubText>Données strictement déstinées à l’équipe de start pour vous contacter</SubText>
              <FormSectionName>Comment contacter le centre d’exposition </FormSectionName>
              <FormInput type="text" placeholder="Numéro de téléphone" />
              <FormInput type="text" placeholder="Site internet" />
              <SubText>Données déstinées aux visiteurs pour vous contacter</SubText>
            </FormContentPage>
            <FormContentPage>
              <FormSectionName>Parlez-nous de votre exposition</FormSectionName>
              <FormInput type="text" placeholder="Titre de l’exposition *" />
              <FormTextarea defaultValue="Description *" />
            </FormContentPage>
            <FormContentPage>
              <FormSectionName>Informations pratiques</FormSectionName>
              <FormInput type="text" placeholder="Tarif normal *" />
              <FormInput type="text" placeholder="Tarif réduit" />
              <FormTextarea defaultValue="Horaires d’ouvertures" />
            </FormContentPage>
            <FormContentPage>
              <FormSectionName>Ajouter des photos à votre description</FormSectionName>
              <SubText>1 photo obligatoire minimum et jusqu’à 8 photos acceptées</SubText>
              <AddPhotoButton>Choisissez une photo</AddPhotoButton>
            </FormContentPage>
          </FormContentWrapper>
          <FormControlsWrapper>
            <FormButton
              disabled={this.state.progress === 0}
              onClick={() => {
                if (this.state.progress > 0) {
                  this.setState((prevState: ProFormState) => ({ progress: prevState.progress - 1 }));
                }
              }}
            >
              Précédent
            </FormButton>
            <FormButton
              onClick={() => {
                if (this.state.progress < 4) {
                  this.setState((prevState: ProFormState) => ({ progress: prevState.progress + 1 }));
                }
                if (this.state.progress === 4) {
                  this.setState({ quizDone: true });
                  window.setTimeout(() => {
                    this.setState({ quizDone: false, progress: 0 });
                  }, 4000);
                }
              }}
            >
              {this.state.progress === 4 ? 'Envoyer' : 'Suivant'}
            </FormButton>
          </FormControlsWrapper>
        </FormWrapper>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// src/app/src/components/ProForm/ProForm.tsx